const prefix = 'wix-form-submitted-';
function getLocalStorage() {
    if (typeof window !== 'undefined' && window.localStorage) {
        return window.localStorage;
    } else {
        return undefined;
    }
}
function parseIds(value) {
    const result = {
        count: 0
    };
    if (!value) {
        return result;
    }
    for (const part of value.split('&')){
        const [key, rawValue] = part.split('=');
        if (rawValue === undefined || rawValue === '' || rawValue === 'undefined' || rawValue === 'null') {
            continue;
        }
        if (key === 'memberId') {
            result.memberId = rawValue;
        } else if (key === 'visitorId') {
            result.visitorId = rawValue;
        } else if (key === 'count') {
            const parsed = Number.parseInt(rawValue, 10);
            if (Number.isFinite(parsed)) {
                result.count = parsed;
            }
        }
    }
    return result;
}
export function setLocalStorageSubmissionLimitValue(formId, visitorId, memberId) {
    if (formId && (memberId || visitorId)) {
        const storage = getLocalStorage();
        if (!storage) {
            return;
        }
        const existing = parseIds(storage.getItem(`${prefix}${formId}`) ?? '');
        const count = existing.count + 1;
        storage.setItem(`${prefix}${formId}`, `memberId=${memberId}&visitorId=${visitorId}&count=${count}`);
    }
}
export function getLocalStorageSubmissionLimitValue(formId) {
    if (formId) {
        const raw = getLocalStorage()?.getItem(`${prefix}${formId}`);
        return raw ? parseIds(raw) : undefined;
    }
    return undefined;
}
export function isSubmissionLimitReached({ formId, submissionLimitPerUser, memberId, visitorId }) {
    if (!submissionLimitPerUser) {
        return false;
    }
    const stored = getLocalStorageSubmissionLimitValue(formId);
    if (!stored?.count) {
        return false;
    }
    const exceedsLimit = submissionLimitPerUser <= stored.count;
    if (!exceedsLimit) {
        return false;
    }
    const memberMatches = Boolean(memberId && memberId === stored.memberId);
    const visitorMatches = Boolean(visitorId && visitorId === stored.visitorId);
    return memberMatches || visitorMatches;
}

//# sourceMappingURL=submission-limit-per-user.js.map